/**
 * The Meetings chat's memory (#12172): the conversation the dock shows, kept
 * per list scope in session storage so moving between the Notetaker's tabs
 * finds it again. It lasts only while the reader stays in the Notetaker
 * (notetaker-documents-parity R15): `NotetakerChatLifetime` forgets it once
 * they go anywhere else.
 */

export const DOCK_MEMORY_PREFIX = "fp-notetaker.dock.";

// Session storage can be unavailable (a private window, blocked site data):
// the dock then simply does not remember.
export function readMemory(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeMemory(key: string, id: string | null): void {
  try {
    if (id) sessionStorage.setItem(key, id);
    else sessionStorage.removeItem(key);
  } catch {
    // Not remembered; nothing else depends on it.
  }
}

/** Forget every conversation the dock is keeping. */
export function forgetDockMemory(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(DOCK_MEMORY_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // Nothing was remembered.
  }
}

/** Whether a path is inside the Notetaker. */
export const isNotetakerPath = (pathname: string): boolean =>
  pathname === "/notetaker" || pathname.startsWith("/notetaker/");
